import {DataTable} from 'react-native-paper';
import React, {Component} from 'react';
import {Animated, View} from 'react-native';
import styled from 'styled-components/native';
import {colours, fontSize, fontWeight, iconSize, spacing} from '@styles/Style';
import {
  GetGlobalTheme,
  GetPasteSpecialValue,
  IsHRWeb,
  requiresSearchForPasteSpecial,
  setPasteSpecialValue,
} from '@tools/displayTools';
import {translate} from '@utils/languageTools';
import EditField from '../EditField';
import Requests from '../../../../api/Requests';
import {ActionButton} from '../../button/ActionButton';
import {handleError} from '../../../../Tools/PortalLog';
import {PasteSpecialSelectedItem} from '@components/editElements/pasteSpecial/PasteSpecialSelectedItem';
import {ScrollViewIndicator} from '@fanchenbao/react-native-scroll-indicator';
import {OutsideClickWrapper} from '@components/editElements/OutsideClickWrapper';
import {PasteSpecialStyledRow} from '@components/editElements/pasteSpecial/PasteSpecialStyledRow';
import {PasteSpecialWindowLayout} from '@utils/types';
import {isStaticPasteSpecial} from '@utils/pasteSpecialUtils';

const PasteSpecialContainer = styled.View`
  background-color: ${colours[GetGlobalTheme()].white};
  border-radius: 12px;
  position: absolute;
  filter: drop-shadow(0 0 6px rgba(107, 107, 107, 0.15));
  margin-top: ${spacing.space12}px;
  top: -8px;
  width: 100%;
  overflow: hidden;
`;

const PasteSpecialHeader = styled.View``;

export const SearchIconStyle = {
  order: -1,
  marginRight: spacing.space8,
};

const SearchBar = {
  backgroundColor: colours[GetGlobalTheme()].white,
  borderColor: colours[GetGlobalTheme()].borderDefault,
  borderRadius: 8,
  borderWidth: 1,
  margin: 0,
  padding: spacing.space12,
  paddingLeft: spacing.space32,
  width: '100%',
};

const SearchWrap = {
  padding: spacing.space4,
  margin: spacing.space4,
};
const ScrollWheelStyle = {
  backgroundColor: colours[GetGlobalTheme()].grey600,
  width: 6,
  borderRadius: 3,
  zIndex: 5,
  marginRight: 4,
};

const PasteSpecialScrollContainer = styled.View`
  height: 200;
  maxheight: 200;
`;

const PasteSpecialContent = styled.View`
  background: ${colours[GetGlobalTheme()].white};
`;

const ColumnTitle = styled.View<{width: number}>`
  color: black;
  width: ${(props) => props.width};
  display: flex;
  align-items: start;
  padding: 0;
`;

const StyledHeader = styled(DataTable.Header)`
  background-color: ${colours[GetGlobalTheme()].white};
  padding-vertical: 0px;
  font-weight: ${fontWeight.bodyBold};
  font-size: ${fontSize.body}px;
  border-bottom-width: 0px;
  height: 36px;
  line-height: 36px;
  padding: 0 ${spacing.space12}px;
  padding-right: ${spacing.space24}px;
  margin: 0;
`;

const Message = styled.Text`
  text-align: center;
  margin-top: 20px;
  color: ${colours[GetGlobalTheme()].black};
`;

const ValueWrap = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  margin: ${spacing.space4}px;
`;

const SelectButtonStyle = {
  margin: spacing.space8,
  background: 'none',
  borderStyle: 'solid',
  borderWidth: 1,
  borderRadius: 12,
};

const SelectButtonTextStyle = {
  color: colours[GetGlobalTheme()].darkBlue,
};

type PasteSpecialWindowState = {
  SearchVal: string;
  activeRecord: any[];
  currentPage: number;
  records: any[];
  multiSelectedRecord: any[];
  inlineNewRecord: boolean;
  canCreateNew: any;
  NewRec: {};
  lastTime: number;
  sortedData: any[];
  currentIndex: number;
  offsetY: any;
  bubbleEntries: string[];
  isLoading: boolean;
};

type PasteSpecialWindowProps = {
  onDisable: () => void;
  isMultiPasteSpecial: boolean;
  sortedPasteSpecial: any;
  mainKey: string;
  value: any;
  table: any;
  psheader: any;
  editfield: any;
  rownr: number;
  windowLayout: PasteSpecialWindowLayout;
  filter: any;
};

export class PasteSpecialWindow extends Component<PasteSpecialWindowProps, PasteSpecialWindowState> {
  searchMinRequiredCharacters = 1;
  lastTime: number;
  dynamicf = false;
  searchRef = React.createRef<View>();
  isStaticPasteSpecial: boolean;
  constructor(props) {
    super(props);
    const self = this;
    this.state = {
      SearchVal: '',
      activeRecord: [],
      currentPage: 0,
      records: [],
      multiSelectedRecord: [],
      inlineNewRecord: false,
      canCreateNew: this.props.psnewrec,
      NewRec: {},
      lastTime: 0,
      sortedData: [],
      currentIndex: -1,
      offsetY: new Animated.Value(-400),
      bubbleEntries: [],
      isLoading: true,
    };
    if (this.props.value === undefined) {
      this.state.activeRecord = [];
      this.state.origValue = '';
      this.state.value = '';
    } else {
      this.state.activeRecord = this.props.value.split2(',');
      this.state.bubbleEntries = this.props.value.split2(',');
      this.state.origValue = this.props.value;
      this.state.value = this.props.value;
    }
    if (requiresSearchForPasteSpecial(this.props.table)) {
      this.dynamicf = true;
    }
    this.showPasteSpecial();
    global.PushKeyActions('Enter', (e) => {
      if (e.shiftKey) {
        self.insertCurrentRecord();
      } else {
        if (this.props.isMultiPasteSpecial) {
          self.selectFromList(0, e, false);
        }
      }
    });
    global.PushKeyActions('ArrowUp', (e) => self.selectFromList(-1, e));
    global.PushKeyActions('ArrowDown', (e) => self.selectFromList(1, e));
    this.isStaticPasteSpecial = isStaticPasteSpecial(this.props.table);
  }

  selectFromList(diff, e, arrowf = true) {
    e.stopPropagation();
    let sortedDataLength = this.state.sortedData.length;
    let newIndex = this.state.currentIndex + diff;
    if (newIndex < sortedDataLength && newIndex >= 0) {
      let id = this.state.sortedData[newIndex][this.props.psheader[0].key];
      this.setCurrentRecord(newIndex, id, arrowf);
    }
  }

  searchPasteSpecial() {
    const self = this;
    const filterCriteria = this.props.filter || {};
    let fields = '';
    this.props.psheader.map((field) => {
      fields += ',' + field.key;
    });

    if (this.isStaticPasteSpecial) {
      this.handleStaticPasteSpecial();
      return;
    }

    this.setState({isLoading: true});
    Requests.getTableData(this.props.table, filterCriteria, fields)
      .then((response) => {
        let records = [];
        if (self.props.table.toString().slice(-5) === 'Block') {
          records = response.records[0].rows;
        } else {
          records = response.records;
        }
        if (self.state.activeRecord.length > 0) {
          for (let i = 0; i < records.length; i++) {
            if (self.state.activeRecord.indexOf(records[i][self.props.psheader[0].key]) > -1) {
              self.state.currentIndex = i;
              i = records.length;
            }
          }
        }

        self.setState({records: records, isLoading: false});
      })
      .catch((error) => {
        handleError(error);
      });
  }

  handleStaticPasteSpecial() {
    const records = global.pasteSpecials[this.props.table];
    this.setState({records: records, isLoading: false});
  }

  searchPasteSpecial2() {
    let self = this;
    this.setState({isLoading: true});

    Requests.getTableData(this.props.table, {}, '', this.state.SearchVal)
      .then((response) => {
        if (self.props.table.toString().slice(-5) === 'Block') {
          self.setState({records: response.records[0].rows});
        } else {
          self.setState({records: response.records, isLoading: false});
        }
      })
      .catch((error) => {
        handleError(error);
      });
  }

  showPasteSpecial() {
    Animated.timing(this.state.offsetY, {toValue: 0, duration: 300}).start();
  }

  getSearchBarComponent = () => {
    if (this.isStaticPasteSpecial) {
      return <></>;
    }

    return (
      <EditField
        inputStyle={SearchBar}
        wrapperStyle={SearchWrap}
        iconName={'SearchIcon'}
        iconStyle={SearchIconStyle}
        iconHeight={iconSize.iconSize}
        value={''}
        reference={this.searchRef}
        onKeyPress={(e) => {
          switch (e.key) {
            case 'ArrowUp':
              e.target.blur();
              this.selectFromList(-1, e);
              break;
            case 'ArrowDown':
              e.target.blur();
              this.selectFromList(1, e);
              break;
            case 'Enter':
              e.target.blur();
              this.selectFromList(1, e);
              break;
            default:
              global.HandleKeyDown(e);
          }
        }}
        onChangeText={(value) => {
          this.setState({SearchVal: value, currentIndex: -1}, () => {
            if (this.dynamicf) {
              if (value.length >= this.searchMinRequiredCharacters) {
                this.searchPasteSpecial2();
              } else {
                this.setState({records: []});
              }
            }
          });
        }}
      />
    );
  };

  windowHeader() {
    const jsxElements = [];

    const isMultiSelectWithDescription =
      this.props.isMultiPasteSpecial && this.props.psheader.some((field) => field.key === 'Comment');
    let shouldRenderHeader = true;
    if (this.props.windowLayout === PasteSpecialWindowLayout.SingleColumnWithDescription || this.isStaticPasteSpecial) {
      shouldRenderHeader = false;
    }

    jsxElements.push(
      <>
        {this.getSearchBarComponent()}
        {this.getBubbleEntries(isMultiSelectWithDescription)}
        {shouldRenderHeader && (
          <StyledHeader key={'paste_header'} style={{marginLeft: this.props.isMultiPasteSpecial ? spacing.space24 : 0}}>
            {this.props.psheader.map((field, index) => (
              <ColumnTitle key={index} width={field.width}>
                {field.name}
              </ColumnTitle>
            ))}
          </StyledHeader>
        )}
      </>
    );

    return jsxElements;
  }

  removeValue(value) {
    let index = this.state.activeRecord.indexOf(value);
    if (index > -1) {
      let activeRecordArr = [...this.state.activeRecord];
      activeRecordArr.splice(index, 1);
      this.setState({activeRecord: activeRecordArr});
      const bubbleEntriesArr = this.state.bubbleEntries.filter((entry) => entry !== value);
      this.setState({bubbleEntries: bubbleEntriesArr});
    }
    index = this.state.multiSelectedRecord.indexOf(value);
    if (index > -1) {
      let multiSelectedRecordArr = [...this.state.multiSelectedRecord];
      multiSelectedRecordArr.splice(index, 1);
      this.setState({multiSelectedRecord: multiSelectedRecordArr});
      const bubbleEntriesArr = this.state.bubbleEntries.filter((entry) => entry !== value);
      this.setState({bubbleEntries: bubbleEntriesArr});
    }
  }

  getBubbleEntries(isMultiSelectWithDescription: boolean) {
    const self = this;
    const res = [];
    const items = [];

    if (!this.props.isMultiPasteSpecial) {
      return res;
    }

    self.state.bubbleEntries.map((value) => {
      const pasteSpecialValue = GetPasteSpecialValue(self.props.table, value);

      items.push(
        <PasteSpecialSelectedItem
          pasteSpecialValue={isMultiSelectWithDescription ? value : pasteSpecialValue}
          onRemoveValue={() => self.removeValue(value)}
        />
      );
    });
    res.push(<ValueWrap>{items}</ValueWrap>);
    return res;
  }

  checkDoubleClick(value) {
    const self = this;
    let canDoubleClick = false;
    let currentDate = Date.now();
    if (currentDate - self.lastTime < 300 && this.state.activeRecord.indexOf(value) > -1) {
      canDoubleClick = true;
    }
    self.lastTime = currentDate;

    return canDoubleClick;
  }

  setCurrentRecord(index, value, arrowf = false) {
    if (arrowf === false && IsHRWeb() && this.checkDoubleClick(value)) {
      this.insertCurrentRecord();
    } else {
      this.setState({currentIndex: index});
      if (this.props.isMultiPasteSpecial) {
        if (arrowf === false) {
          let index = this.state.activeRecord.indexOf(value);
          let index2 = this.state.multiSelectedRecord.indexOf(value);
          if (index < 0 && index2 < 0 && value !== '') {
            this.setState({
              multiSelectedRecord: [...this.state.multiSelectedRecord, value],
            });
            this.setState({bubbleEntries: [...this.state.activeRecord, ...this.state.multiSelectedRecord, value]});
          }
        }
      } else {
        this.setState({activeRecord: [value]}, () => {
          if (IsHRWeb() === false) {
            this.insertCurrentRecord();
          }
        });
      }
    }
  }

  insertCurrentRecord() {
    if (this.props.onChange !== undefined) {
      let val = [...this.state.activeRecord, ...this.state.multiSelectedRecord].join(',');
      if (this.state.origValue !== val) {
        this.props.onChange({
          rowindex: this.props.rownr,
          fieldname: this.props.name,
          value: val,
        });
      }
    }
    this.props.onDisable();
  }

  styledRow(rowindex, length, record) {
    const self = this;
    const id = record[this.props.psheader[0].key];
    setPasteSpecialValue(this.props.table, id, record);

    return (
      <PasteSpecialStyledRow
        rowIndex={rowindex}
        length={length}
        record={record}
        psheader={self.props.psheader}
        isMultiPasteSpecial={self.props.isMultiPasteSpecial}
        mainKey={self.props.mainKey}
        windowLayout={self.props.windowLayout}
        table={''}
        activeRecord={self.state.activeRecord}
        multiSelectedRecord={self.state.multiSelectedRecord}
        currentIndex={self.state.currentIndex}
        setCurrentRecord={(rowIndex: number, id: string) => {
          self.setCurrentRecord(rowIndex, id);
        }}
        removeValue={(code: string) => {
          self.removeValue(code);
        }}
        firstColumnSuffixKey={self.props.firstColumnSuffixKey}
      />
    );
  }

  sortAndSearchTableData(tableData) {
    let slicedTableData = tableData.slice();
    let searchParameter = this.state.SearchVal.toLowerCase();

    if (searchParameter !== '') {
      slicedTableData = slicedTableData.filter((item) => {
        return JSON.stringify(item).toLowerCase().indexOf(searchParameter) > -1;
      });
    }

    if (this.props.sortedPasteSpecial) {
      slicedTableData = this.getSortedTableData(tableData);
    }

    return slicedTableData;
  }

  getSortedTableData(tableData) {
    const tableDataCopy = tableData;
    const curDir = this.props.sortedPasteSpecial.dir;
    tableDataCopy.sort((a, b) => {
      if (curDir === 'ascending') {
        return a[this.props.sortedPasteSpecial.key] > b[this.props.sortedPasteSpecial.key] ? 1 : -1;
      } else {
        return a[this.props.sortedPasteSpecial.key] < b[this.props.sortedPasteSpecial.key] ? 1 : -1;
      }
    });
    return tableDataCopy;
  }

  recordList() {
    let recordList = [];
    let tdata = this.state.records;
    if (this.dynamicf === false) {
      tdata = this.sortAndSearchTableData(this.state.records);
    }
    this.state.sortedData = tdata;
    recordList.push(
      <DataTable primaryKey={'paste_body'}>
        {tdata.map((record, index) => {
          return this.styledRow(index, tdata.length, record);
        })}
        {tdata.length === 0 && this.dynamicf && this.state.SearchVal.length < this.searchMinRequiredCharacters && (
          <Message>{translate('StartTyping')}</Message>
        )}
        {tdata.length === 0 &&
        (this.dynamicf === false || this.state.SearchVal.length > this.searchMinRequiredCharacters - 1) ? (
          this.state.isLoading ? (
            <Message>{translate('LoadingPleaseWait')}</Message>
          ) : (
            <Message>{translate('NoData')}</Message>
          )
        ) : (
          <></>
        )}
      </DataTable>
    );

    return recordList;
  }

  getPasteSpecialScrollContainerStyle = () => {
    const styleObj = {
      height: this.isStaticPasteSpecial ? '100%' : 200,
    };
    return styleObj;
  };

  componentWillUnmount() {
    global.PopKeyActions('Enter');
    global.PopKeyActions('ArrowUp');
    global.PopKeyActions('ArrowDown');
  }

  componentDidMount() {
    if (this.searchRef.current) {
      this.searchRef.current.focus();
    }
    if (this.dynamicf === false) {
      this.searchPasteSpecial();
    }
  }

  render() {
    return (
      <OutsideClickWrapper onOutsideClick={() => this.insertCurrentRecord()}>
        <PasteSpecialContainer>
          <PasteSpecialContent>
            <PasteSpecialHeader>{this.windowHeader()}</PasteSpecialHeader>
            <PasteSpecialScrollContainer style={this.getPasteSpecialScrollContainerStyle()}>
              <ScrollViewIndicator indStyle={ScrollWheelStyle}>{this.recordList()}</ScrollViewIndicator>
            </PasteSpecialScrollContainer>
            {this.props.isMultiPasteSpecial && (
              <ActionButton
                style={SelectButtonStyle}
                textStyle={SelectButtonTextStyle}
                onPress={() => this.insertCurrentRecord()}
                title={translate('Select')}
              />
            )}
          </PasteSpecialContent>
        </PasteSpecialContainer>
      </OutsideClickWrapper>
    );
  }
}
